// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "-legacy." + {"56":"6736c8bc","176":"7feb7c50","466":"fde7732d"}[chunkId] + ".js";
};